import { defineComponent, computed, ref, watch } from 'vue';
import { VueFinalModal } from 'vue-final-modal';
import ButtonNew from '@hems/component/src/buttons/ButtonNew.vue';
import Image from '@hems/component/src/image/Image.vue';
import { useLoading } from '@hems/util/src/composable/loading';
import { BUTTON_NEW_TYPE } from '@hems/util/src/constant/button';
const MESSAGE_MODAL_TYPE = {
    WARNING: 'WARNING',
    DANGER_CONFIRMATION: 'DANGER_CONFIRMATION',
    CONFIRMATION: 'CONFIRMATION',
};
export default defineComponent({
    name: 'MessageModal',
    components: { VueFinalModal, Image, ButtonNew },
    props: {
        type: {
            type: String,
            default: MESSAGE_MODAL_TYPE.CONFIRMATION,
        },
        title: {
            type: String,
            required: true,
        },
        content: {
            type: String,
            required: true,
        },
        confirmButtonText: {
            type: String,
            default: '',
        },
        cancelButtonText: {
            type: String,
            default: '',
        },
        clickToClose: {
            type: Boolean,
            default: false,
        },
        confirmButtonType: {
            type: String,
            default: undefined,
        },
        cancelButtonType: {
            type: String,
            default: undefined,
        },
    },
    emits: ['confirm', 'cancel'],
    setup(props, { emit }) {
        const { resetLoading } = useLoading();
        resetLoading();
        const iconName = computed(() => (props.type === MESSAGE_MODAL_TYPE.CONFIRMATION ? 'img_check_72' : 'img_error'));
        const isDangerAction = computed(() => props.type === MESSAGE_MODAL_TYPE.DANGER_CONFIRMATION);
        const buttonRefs = ref([]);
        const isVerticalButton = ref(false);
        const buttonArrangeClass = computed(() => {
            if (isVerticalButton.value) {
                return 'flex-column';
            }
            return isDangerAction.value ? 'flex-row-reverse' : 'flex-row';
        });
        const confirmBtnType = computed(() => {
            if (props.confirmButtonType)
                return props.confirmButtonType;
            return isDangerAction.value ? BUTTON_NEW_TYPE.OTL : BUTTON_NEW_TYPE.SOLID;
        });
        const cancelBtnType = computed(() => {
            if (props.cancelButtonType)
                return props.cancelButtonType;
            return props.type === MESSAGE_MODAL_TYPE.DANGER_CONFIRMATION ? BUTTON_NEW_TYPE.SOLID : BUTTON_NEW_TYPE.OTL;
        });
        const onClose = (close) => {
            emit('cancel');
            close();
        };
        const checkButtonTextOverflow = () => {
            isVerticalButton.value = buttonRefs.value.some((btn) => {
                if (!btn)
                    return false;
                return btn.scrollHeight > btn.clientHeight;
            });
        };
        const onButtonMounted = (button) => {
            buttonRefs.value.push(button);
            checkButtonTextOverflow();
        };
        watch(() => [props.confirmButtonText, props.cancelButtonText], () => {
            checkButtonTextOverflow();
        });
        return {
            iconName,
            isDangerAction,
            confirmBtnType,
            cancelBtnType,
            MESSAGE_MODAL_TYPE,
            buttonArrangeClass,
            onClose,
            onButtonMounted,
        };
    },
});
